module.exports = __webpack_public_path__ + "static/media/background.502312cb.png";